import {PartnerBrandVehiclesImportApiDto} from "../../api/model/rest";

export class PartnerBrandVehiclesImportResult {
	constructor(
		public readonly successNewCount: number,
		public readonly successExistingCount: number,
		public readonly invalidRegistrationCount: number
	) {}

	static fromJson(json: PartnerBrandVehiclesImportApiDto): PartnerBrandVehiclesImportResult {
		return new PartnerBrandVehiclesImportResult(
			json.successNewCount || 0,
			json.successExistingCount || 0,
			json.invalidRegistrationCount || 0
		);
	}

	get totalCount(): number {
		return this.successNewCount + this.successExistingCount + this.invalidRegistrationCount;
	}
}
